import {
  GET_TRIGGER_ORDER_QUOTE_SUCCESS,
  GET_TRIGGER_ORDER_QUOTE_ERROR,
  EXECUTE_TRIGGER_ORDER_QUOTE_SUCCESS,
  EXECUTE_TRIGGER_ORDER_QUOTE_ERROR,
} from '../../actions/triggerOrders/triggerOrdersActionConstants';
import createReducer from '../../utils/createReducer';

const initialState = {
  quote: null,
  executedQuote: null,
  errorMessage: '',
};

export default createReducer(
  {
    [GET_TRIGGER_ORDER_QUOTE_SUCCESS]: getTriggerOrderQuoteSuccess,
    [GET_TRIGGER_ORDER_QUOTE_ERROR]: triggerOrderQuoteError,
    [EXECUTE_TRIGGER_ORDER_QUOTE_SUCCESS]: executeTriggerOrderQuoteSuccess,
    [EXECUTE_TRIGGER_ORDER_QUOTE_ERROR]: triggerOrderQuoteError,
  },
  initialState,
);

function getTriggerOrderQuoteSuccess(state, action) {
  return {
    ...state,
    quote: action.payload,
    errorMessage: '',
  };
}

function executeTriggerOrderQuoteSuccess(state, action) {
  return {
    ...state,
    executedQuote: action.payload,
    errorMessage: '',
  };
}

function triggerOrderQuoteError(state, action) {
  return {
    ...state,
    errorMessage: action.payload,
  };
}
